import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'
import { supportApi } from './api/supportApi'
import authReducer from './slices/authSlice'
import themeReducer from './slices/themeSlice'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]:  apiSlice.reducer,
    [supportApi.reducerPath]: supportApi.reducer,
    auth:  authReducer,
    theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(apiSlice.middleware)
      .concat(supportApi.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
